// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g9-9";
export var fulfillmentFormRail = "_g9-8";
export var headerTitleRow = "_g9-b";
export var orderDetailsWrapper = "_g9-6";
export var paymentInformationGrid = "_g9-g";
export var paymentSummaryColumn = "_g9-h";
export var shipmentContainer = "_g9-a";
export var shipmentDetailsMainPane = "_g9-7";
export var shipmentNavigationCard = "_g9-4";
export var shipmentNavigationRail = "_g9-2";
export var shipmentNavigationRailHeader = "_g9-3";
export var shipmentSummaryFact = "_g9-d";
export var shipmentSummaryGrid = "_g9-c";
export var shipmentSummaryMetadataRow = "_g9-e";
export var shipmentSummaryTags = "_g9-f";
export var shipmentWorkspace = "_g9-0";
export var shipmentWorkspaceContent = "_g9-5";
export var shipmentWorkspaceHeader = "_g9-1";